"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingOperationFactory = void 0;
var _1 = require(".");
var priceGuidePricingOperation_1 = require("./priceGuidePricingOperation");
var PricingOperationFactory = /** @class */ (function () {
    function PricingOperationFactory() {
    }
    PricingOperationFactory.create = function (params) {
        switch (params.strategy.base.kind) {
            case 'articleData':
                return new _1.CompetitionPricingOperation(params);
            case 'priceGuide':
                return new priceGuidePricingOperation_1.PriceGuidePricingOperation(params);
            default:
                throw new Error("Unknown pricing strategy: ".concat(params.strategy.base.kind));
        }
    };
    return PricingOperationFactory;
}());
exports.PricingOperationFactory = PricingOperationFactory;
//# sourceMappingURL=pricingOperationFactory.js.map